import { Icon } from "@iconify/react";
import { Button, Modal } from "antd";

export default function ConfirmModal({
  onClose,
  open,
  action,
  title,
  description,
  pending,
  success = false,
}: {
  open: boolean;
  onClose: () => void;
  action: () => void;
  title: string;
  description: string;
  pending: boolean;
  success?: boolean;
}) {
  return (
    <Modal
      open={open}
      closeIcon={false}
      onCancel={onClose}
      classNames={{
        footer: "hidden!",
        header: "hidden!",
        body: "px-4! flex! flex-col! gap-6!",
      }}
    >
      <div className="w-full items-center flex flex-col gap-8">
        <div className="w-full flex justify-center">
          <div
            className={`w-16 aspect-square ${success ? "bg-success-100 text-success-500" : "bg-error-100 text-error-500"} flex-center rounded-2xl`}
          >
            <Icon
              icon={
                success ? "ic:baseline-check" : "solar:trash-bin-trash-linear"
              }
              className="text-4xl"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 items-center">
          <span className="display-24-semi-bold text-center">{title}</span>
          <span className="text-18-regular text-grayscale-600 text-center">
            {description}
          </span>
        </div>
      </div>
      <div className="w-full flex gap-2">
        <Button onClick={onClose} className="w-1/2!">
          لغو
        </Button>
        <Button
          loading={pending}
          onClick={action}
          danger={success ? false : true}
          type="primary"
          className={`w-1/2! ${success ? "text-white! bg-success-600!" : ""}`}
        >
          {success ? "تایید" : "حذف"}
        </Button>
      </div>
    </Modal>
  );
}
